import React from 'react'
import { useTranslation } from 'react-i18next'

import type { PaymentMethod } from '~/constants/addPaymentDialogV2Constants'

import NumberField from './NumberField'
import PaymentDropdown, { type PaymentDropdownOption } from './PaymentDropdown'

interface ChargeablePaymentFieldsProps {
  amountToCharge: string
  isDisabled: boolean
  onAmountChange: (value: string) => void
  onMethodChange: (value: PaymentMethod) => void
  paymentMethods: PaymentDropdownOption[]
  selectedMethod: PaymentMethod
  validationMessage?: string | null
}

const ChargeablePaymentFields = ({
  selectedMethod,
  amountToCharge,
  isDisabled,
  paymentMethods,
  onMethodChange,
  onAmountChange,
  validationMessage,
}: ChargeablePaymentFieldsProps) => {
  const { t } = useTranslation(['Common', 'Dialogs'])
  const NumberValue = parseFloat(amountToCharge)
  const formattedAmountToCharge = !Number.isNaN(NumberValue)
    ? NumberValue.toFixed(2)
    : amountToCharge

  return (
    <>
      <PaymentDropdown
        disabled={isDisabled}
        label={t('Common:PAYMENTS.PAYMENT_METHOD')}
        options={paymentMethods}
        value={selectedMethod}
        onChange={(value) => onMethodChange(value as PaymentMethod)}
      />
      <NumberField
        isMoney
        required
        disabled={isDisabled}
        label={t('Dialogs:ADD_PAYMENT_DIALOG_V2.AMOUNT_TO_CHARGE')}
        validationMessage={validationMessage}
        value={formattedAmountToCharge}
        onChange={onAmountChange}
      />
    </>
  )
}

export default ChargeablePaymentFields
